import { userCareTeamV2 } from '@fireflyhealth/api'
import { useQuery } from '~/shared/hooks/query'

/** A patient's care team, keyed by their user id. */
export const useCareTeam = (userId: number | null) =>
  useQuery(
    ['careTeam', userId],
    async () => (await userCareTeamV2.list({ patient_id: String(userId) })).data,
    {
      enabled: !!userId,
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes since care team doesn't change frequently
    },
  )
